 
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from './components/App';
import "./index.css";

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // react-snap pre-rendered HTML exists — hydrate it
  hydrateRoot(
    rootElement,
    <BrowserRouter basename="/marquis-aura-cpc-dubai">
      <App />
    </BrowserRouter>
  );
} else {
  // Normal React render
  createRoot(rootElement).render(
    <BrowserRouter basename="/marquis-aura-cpc-dubai">
      <App />
    </BrowserRouter>
  );
}